import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=3bedf7c8&scoped=true&"
import script from "./TextInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=3bedf7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bedf7c8",
  null
  
)

export default component.exports